import * as React from "react";

import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    margin: "10px auto",
    padding: "20px 10px",
    border: "solid 1px #B6B3B3",
  },
  p: {
    padding: 10,
  },
  t1: {
    color: "#0A369D",
    fontWeight: "bold",
    fontSize: 18,
  },
  t2: {
    color: "#292929",
    fontSize: 16,
    fontFamily: "Vazir",
    marginTop: 5,
    lineHeight: 1.7,
    textAlign: "justify",
  },
  t3: {
    color: "#292929",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 10,
  },
}));

const About = ({ data }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      {data && (
        <Grid item xs={12} className={classes.p}>
          <Typography variant="h2" className={classes.t1}>
            درباره ما
          </Typography>
          <p className={classes.t2}>{data.description}</p>
          <Typography variant="h3" className={classes.t3}>
            محور فعالیت
          </Typography>
          <Typography variant="h4" className={classes.t2}>
            {data.activity_axios?.map((item, i) =>
              i + 1 === data.activity_axios.length
                ? item.name
                : `${item.name}، `
            )}
          </Typography>
          <Typography variant="h3" className={classes.t3}>
            گروه هدف
          </Typography>
          <Typography variant="h4" className={classes.t2}>
            {data.target_groups?.map((item, i) =>
              i + 1 === data.target_groups.length ? item.name : `${item.name}، `
            )}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default About;
